export default __webpack_public_path__ + "static/media/Terms & Conditions of Sale.0092ba65.pdf";